import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import TripDetail from '@/components/TripDetail'
import Score from '@/components/Score'
import Econtact from '@/components/Econtact'
import Signature from '@/components/Signature'

import NewContact from '@/components/NewContact'
import NewSignature from '@/components/NewSignature'
import NewMainContact from '@/components/NewMainContact'

import MainContact from '@/components/MainContact'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: { keepAlive: false, isBack: false }
    },
    {
      path: '/HomePage',
      name: 'Home',
      component: Home,
      meta: { keepAlive: true, isBack: false }
    },
    {
      path: '/TripDetail',
      name: 'TripDetail',
      component: TripDetail,
      meta: { keepAlive: false, isBack: false }
    },
    {
      path: '/Score',
      name: 'Score',
      component: Score,
      meta: { keepAlive: false, isBack: false }
    }, {
      path: '/Econtact',
      name: 'Econtact',
      component: Econtact,
      meta: { keepAlive: false, isBack: false }
    }
    , {
      path: '/Signature',
      name: 'Signature',
      component: Signature,
      meta: { keepAlive: false, isBack: false }
    }
    , {
      path: '/MainContact',
      name: 'MainContact',
      component: MainContact,
      meta: { keepAlive: false, isBack: false }
    }
    , {
      path: '/NewContact',
      name: 'NewContact',
      component: NewContact,
      meta: { keepAlive: false, isBack: false }
    }
    , {
      path: '/NewSignature',
      name: 'NewSignature',
      component: NewSignature,
      meta: { keepAlive: false, isBack: false }
    },
    , {
      path: '/NewMainContact',
      name: 'NewMainContact',
      component: NewMainContact,
      meta: { keepAlive: false, isBack: false }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js